module.exports = __webpack_public_path__ + "1.5.0-unryo/img/na.6889cacf.svg";